<template>
  <div>
    <router-link class="list-group-item" to="/analysis/scan/labelid/all" active-class="active">
      <i class="el-icon-more"></i><span class="m-l">所有二维码</span>
    </router-link>
    <div class="m-l m-t"><strong>标签分类</strong></div>
    <template v-for="qrlabel in qrlabelList">
      <router-link class="list-group-item" :to="'/analysis/scan/labelid/'+qrlabel.id" active-class="active" :key="qrlabel.id">
        <qrLabelItem :qrlabel="qrlabel"></qrLabelItem>
      </router-link>
    </template>
  </div>
</template>

<script type="text/javascript">
import qrLabelItem from '../labelManage/qrLabelItem.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'qrLabelList',
  components: {
    qrLabelItem
  },
  computed: {
    ...mapGetters(['qrlabelList'])
  }
}
</script>

<style type="text/css" scoped>
.list-group-item {
  border: 1px solid #CCC;
  font-size: 14px;
  color: black;
  padding: 10px 25px;
  display: block;
  border-color:#e4e9ed;
  text-decoration: none;
}
.active {
  background-color: #e1e5e9;
}
</style>
